<template>
  <div>
    <a-form :form="form">
      <a-row :gutter="16">
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
          <a-form-item label="Date">
            <a-date-picker
              placeholder="Select Date"
              :disabled="mode === 'Edit'"
              :format="getDefaultDateFormat"
              v-decorator="[
                'tgl_buat',
                {
                  rules: [{ required: true }],
                  initialValue: moment(
                    initialData.informasi.tgl_buat,
                    getDefaultDateFormat
                  ),
                },
              ]"
            />
          </a-form-item>
          <a-form-item label="Sales Contract">
            <a-select
              :disabled="
                mode == 'Edit' ||
                (this.collectData.detilTermin !== undefined &&
                  this.collectData.detilTermin.length > 0)
              "
              showSearch
              :not-found-content="null"
              option-filter-prop="children"
              v-decorator="[
                'sales_contract',
                {
                  rules: [{ required: true }],
                  initialValue: initialData.informasi.sales_contract,
                },
              ]"
              @change="handleSalesContract"
            >
              <a-select-option
                v-for="item in getterminsalesContract"
                :key="item.id_sales_contract"
                >{{item.no_sales_contract}} | {{ item.no_contract }}</a-select-option
              >
            </a-select>
            <div class="m-form-description"><b>Contract Code : </b>{{labelingSalesContract}} <br/><b>Description : </b> {{labelingSalesContract1}}</div>
          </a-form-item>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
          <a-form-item label="Note">
            <a-textarea
              placeholder="Write the note here ... "
              :rows="4"
              v-decorator="['note',{initialValue : initialData.informasi.note}]"
            />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <a-modal
      v-model="modalanggaran.visible"
      v-if="modalanggaran.visible"
      title="Choice Financing Code"
      :footer="null"
      :width="700"
    >
      <a-tree-select
        v-model="modalanggaran.value"
        show-search
        style="width: 100%"
        @change="handlechoiceCost"
        :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
        :tree-data="modalanggaran.tree"
        treeNodeFilterProp="children"
        :filterTreeNode="filterTreeNode"
        placeholder="Please select"
        allow-clear
        tree-default-expand-all
      >
        <span slot="title" slot-scope="item">
          <table style="width: 100%">
            <tr>
              <td>
                <span> {{ item.texttitle }} - {{ item.kode_anggaran }}</span>
              </td>
              <td>
                <span style="float: right">
                  {{ formatRupiah(parseFloat(item.rekap)) }}
                </span>
              </td>
            </tr>
          </table>
        </span>
      </a-tree-select>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import _ from "lodash";
export default {
  name: "Informasi",
  props: {
    collectData: {},
    mode: String,
  },
  mixins: [CurrencyFormat],
  data() {
    return {
      labelingSalesContract: "",
      labelingSalesContract1: "",
      peruntukan: [],
      subPeruntukan: [],
      anggaran: [],
      costCenter: [],
      modalanggaran: {
        visible: false,
        enabled: false,
        loadingButton: false,
        value: undefined,
        tree: {},
        searchValue: "",
      },
      loadUserfor: false,
      disabledUserfor: true,
      listUseFor: [
        {
          text: "Technic item/service purchasing",
          value: "1",
        },
        {
          text: "Non technic item/service purchasing",
          value: "2",
        },
        {
          text: "Payment instruction",
          value: "3",
        },
        {
          text: "Commission",
          value: "4",
        },
        {
          text: "Other",
          value: "5",
        },
      ],
      // visible:{
      //   vjAnggaran: false,
      //   vjCostCenter: false,
      //   vjPeruntukan: false,
      //   vjSUbPeruntukan: false,
      //   vjKodeAnggaran: false,
      //
      // }
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters([
      "getAllKaryawan",
      "getDefaultDateFormat",
      "getAuth",
      "getCostCenter",
      "getPeruntukan",
      "getSubPeruntukan",
      "getAnggaran",
      "getterminsalesContract",
    ]),
    initialData() {
      let informasi = {};
      if (this.collectData === undefined || this.collectData.length == 0) {
        informasi = {
          tgl_buat: moment().utc(true),
          sales_contract: null,
          note: "",
        };
        return { informasi };
      } else {
        informasi = {
          tgl_buat: moment(this.collectData.informasi.tgl_transaksi).format(
            this.getDefaultDateFormat
          ),
          sales_contract: this.collectData.informasi.sales_contract,
          note: this.collectData.informasi.note,
        };
        this.handleSalesContract(this.collectData.informasi.sales_contract);
        return { informasi };
      }
    },
  },
  created() {
    this.$store.dispatch("getListsalesContract");
  },
  mounted() {
  },
  methods: {
    moment,
    handleCodeAnggarn(e) {
      let forms = this.form.getFieldsValue();
      this.modalanggaran.value =
        forms.peruntukan + ";" + forms.sub_peruntukan + ";" + e;
    },
    filterTreeNode(input, option) {
      return (
        option.data.props.texttitle == undefined ||
        (option.data.props.texttitle ? option.data.props.texttitle : "")
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0 ||
        (option.data.props.kode_anggaran ? option.data.props.kode_anggaran : "")
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handlechoiceCost(val) {
      if (val) {
        let kod = val.split(";");
        this.$nextTick(function () {
          this.handlePeruntukan(kod[0]);
          this.form.setFieldsValue({
            peruntukan: kod[0],
          });
          //this.handleSubPeruntukan(kod[1]);
          this.form.setFieldsValue({
            sub_peruntukan: kod[1],
            kode_anggaran: kod[2],
          });
        });
      } else {
        this.$nextTick(function () {
          this.form.setFieldsValue({
            peruntukan: undefined,
            sub_peruntukan: undefined,
            kode_anggaran: undefined,
          });
        });
      }
      this.modalanggaran.visible = false;
    },
    showChoiceModal() {
      this.modalanggaran.visible = true;
    },
    handlePeruntukan(e) {
      this.modalanggaran.value = undefined;
      this.form.resetFields(["sub_peruntukan", "kode_anggaran"]);
      this.anggaran = [];
      const filter = this.getSubPeruntukan.filter(
        (obj) => obj.peruntukan_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );
      this.subPeruntukan = filter;
    },
    handleRef() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        //let approval = "";
        // this.getApproval(values.kode_anggaran)
        //   .then((res) => {
        //     //approval = res.data;
        //     const dataValues = {
        //       ...values,
        //       tgl_buat: moment(values.tgl_buat).format(
        //         this.getStandartFormatDate
        //       ),
        //       be_required: moment(values.be_required).format(
        //         this.getStandartFormatDate
        //       ),
        //       //approval: res.data.approval,
        //     };
        //     Event.$emit("ppData", {
        //       informasi: dataValues,
        //     });
        //   })
        //   .catch((err) => {
        //     if (err.response) {
        //       this.$notification.error({
        //         message: "Error Message",
        //         description: err.response.data.message,
        //       });
        //     }
        //     return err;
        //   });
        values.tgl_transaksi = values.tgl_buat;
        const dataValues = {
          ...values,
        };
        Event.$emit("terminReleaseData", {
          informasi: dataValues,
        });
      });
    },
    handleSalesContract(e) {
      let tempval = _.filter(this.getterminsalesContract, (item) => item.id_sales_contract==e);
      if(tempval.length>0){
        this.labelingSalesContract = tempval[0].kode_contract;
        this.labelingSalesContract1 = tempval[0].description;
      }
    },
    initJenisAnggaran(e) {
      let filter = this.getCostCenter.filter(
        (obj) => obj.jns_anggaran_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );

      this.modalanggaran.enabled = false;
      this.costCenter = filter;
    },
    initCost(e) {
      this.modalanggaran.enabled = false;
      this.modalanggaran.loadingButton = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "anggaran/tree_anggaran",
        params: {
          anggaran_id: e,
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          //console.log(response);
          this.modalanggaran.enabled = true;
          this.modalanggaran.loadingButton = false;
          this.modalanggaran.tree = response.data.tree;
        })
        .catch((err) => {
          let responses = Object.assign({}, err.response);
          console.log(responses);
        });

      this.form.resetFields(["peruntukan", "sub_peruntukan", "kode_anggaran"]);

      // this.subPeruntukan = [];
      // this.anggaran = [];
      const peruntukan = this.getPeruntukan.filter(
        (obj) => obj.anggaran_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );
      this.peruntukan = peruntukan;
    },
  },
};
</script>

<style lang="less">
.ant-select-selection-selected-value {
  width: 100%;
}
</style>
